import { RELATION_HAS_PART } from '@backstage/catalog-model';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  EntityCardBlueprint,
  EntityRelationCard,
  entityDataTableColumns,
} from '@backstage/plugin-catalog-react/alpha';

const systemPartsCard = EntityCardBlueprint.make({
  name: 'system-parts',
  params: {
    filter: { kind: 'system' },
    loader: async () => (
      <EntityRelationCard
        title="APIs, servicios y frontends"
        relationType={RELATION_HAS_PART}
        columnConfig={[
          entityDataTableColumns.createEntityRefColumn({}),
          entityDataTableColumns.createSpecTypeColumn(),
          entityDataTableColumns.createOwnerColumn(),
          entityDataTableColumns.createSpecLifecycleColumn(),
          entityDataTableColumns.createMetadataDescriptionColumn(),
        ]}
        emptyState={{
          message: 'Este sistema aún no tiene APIs, servicios ni frontends.',
        }}
      />
    ),
  },
});

export const catalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [systemPartsCard],
});
